@if (content) {
    <div class="url-container">
        <p class="url-description">Public URL</p>
        <p class="url">{{ pageUrl }}</p>
        <button (click)="onClick()">Copy</button>
    </div>
    <ul class="list">
        @for (message of messages; track $index) {
            <li [class]="message.type">
                <p>{{ message.message }}</p>
            </li>
        }
    </ul>
}
